import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6501d9bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address-input-container" }
const _hoisted_2 = { class: "address-input-wrapper" }
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 0,
  class: "required"
}
const _hoisted_5 = ["id", "name", "value", "disabled"]
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["name", "value", "disabled"]
const _hoisted_8 = { class: "description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($props.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: $props.name
          }, [
            _createElementVNode("span", null, _toDisplayString($props.label), 1 /* TEXT */),
            ($props.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
              : _createCommentVNode("v-if", true)
          ], 8 /* PROPS */, _hoisted_3))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["Field"], {
        name: $props.name,
        type: "text",
        modelValue: $setup.roadAddress,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.roadAddress) = $event)),
        rules: $props.rules
      }, {
        default: _withCtx(({ errorMessage }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["text-input", {
            error: errorMessage,
            disabled: $props.disabled,
          }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowAddressModal(true)))
          }, [
            _createElementVNode("input", {
              class: "input--base",
              type: "text",
              id: $props.name,
              name: `${$props.name}-zonecode`,
              value: $props.value?.zipNo,
              disabled: $props.disabled,
              readonly: ""
            }, null, 8 /* PROPS */, _hoisted_5),
            _createElementVNode("button", {
              class: "btn",
              type: "button",
              "aria-label": `${$props.label} 검색`
            }, " 검색 ", 8 /* PROPS */, _hoisted_6)
          ], 2 /* CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass(["text-input", {
            error: errorMessage,
            disabled: $props.disabled,
          }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleShowAddressModal(true)))
          }, [
            _createElementVNode("input", {
              class: "input--base",
              type: "text",
              name: $props.name,
              value: $props.value?.roadAddress,
              disabled: $props.disabled,
              readonly: ""
            }, null, 8 /* PROPS */, _hoisted_7)
          ], 2 /* CLASS */),
          _createVNode($setup["TextInput"], {
            name: `${$props.name}-detail`,
            placeholder: "상세 주소를 입력하세요",
            errorMessage: errorMessage,
            disabled: $props.disabled,
            value: $setup.detailAddress,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($setup.detailAddress) = $event))
          }, null, 8 /* PROPS */, ["name", "errorMessage", "disabled", "value"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["name", "modelValue", "rules"]),
      _createElementVNode("p", _hoisted_8, _toDisplayString($props.placeholder), 1 /* TEXT */)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#center" }, [
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowAddressModal,
        onBackHandler: () => $setup.toggleShowAddressModal(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["KakaoAddressModal"], {
            onUpdateAddress: $setup.updateAddress,
            onOnClickClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleShowAddressModal(false)))
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ]))
  ]))
}